<div class="modal" tabindex="-1" #confirm>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="px-4 py-3">
        <div class="row">
          <div class="col question">{{ message }}</div>
        </div>

        <div class="row mt-4">
          <div class="col">
            <button (click)="enter()" class="btn btn-primary w-100"><i class="fas fa-check me-3"></i>Yes</button>
          </div>

          <div class="col">
            <button (click)="escape()" class="btn btn-outline-primary w-100"><i class="fas fa-times me-3"></i>No</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
